import { useState } from "react";
import { t } from "i18next";
import { addRecharge } from "actions/rechargeActions";
import { useDispatch } from "react-redux";

const useFormTopup = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();

    const handleAddTopUp = async (data) => {
        setError(null);
        setLoading(true);
        try {
            const res = await dispatch(addRecharge(data));
            return res;
        } catch (err) {
            setError(t(err.message));
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, handleAddTopUp };
};

export default useFormTopup;
